/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellOffIcon16Light = forwardRef('NotificationBellOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.354.146a.5.5 0 1 0-.708.708L3.913 3.12A4.977 4.977 0 0 0 3 6v2.862l-1.429 2.38A.5.5 0 0 0 2 12h4v.5a2 2 0 1 0 4 0V12h2.793l1.853 1.854a.5.5 0 0 0 .708-.708l-13-13ZM11.793 11l-7.16-7.16A3.981 3.981 0 0 0 4 6v3a.5.5 0 0 1-.071.257L2.883 11h8.91ZM7 12v.5a1 1 0 1 0 2 0V12H7Z" }),
        React.createElement("path", { d: "M12 6v1.869l1.01 1.01-.01-.017V6a5 5 0 0 0-7.306-4.438l.75.752A4 4 0 0 1 12 6Z" })));
});
